var _path, _path2, _path3, _g, _path4, _path5, _path6, _g2, _path7, _g3, _path8, _path9, _path10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.6 175C59.1775 175 25.6001 141.423 25.6001 100C25.6001 58.5774 59.1775 25 100.6 25C142.023 25 175.6 58.5774 175.6 100C175.6 141.423 142.023 175 100.6 175Z",
    fill: "url(#paint0_linear_26801_1307)",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9381 35H41.6001C38.2864 35 35.6001 37.6863 35.6001 41V159C35.6001 162.314 38.2864 165 41.6001 165H90.9381C94.2518 165 96.9381 162.314 96.9381 159V41C96.9381 37.6863 94.2518 35 90.9381 35Z",
    fill: "url(#paint1_linear_26801_1307)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26801_1307",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 35,
    width: 62,
    height: 130
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9381 35H41.6001C38.2864 35 35.6001 37.6863 35.6001 41V159C35.6001 162.314 38.2864 165 41.6001 165H90.9381C94.2518 165 96.9381 162.314 96.9381 159V41C96.9381 37.6863 94.2518 35 90.9381 35Z",
    fill: "url(#paint2_linear_26801_1307)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26801_1307)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_26801_1307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.9381 131.454L84.8518 112.817L71.1293 133.446L63.7008 122.685L35.6001 165H96.9381V131.454Z",
    fill: "white"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M159.6 35H110.262C106.948 35 104.262 37.6863 104.262 41V90.338C104.262 93.6517 106.948 96.338 110.262 96.338H159.6C162.914 96.338 165.6 93.6517 165.6 90.338V41C165.6 37.6863 162.914 35 159.6 35Z",
    fill: "url(#paint3_linear_26801_1307)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M159.6 103.662H110.262C106.948 103.662 104.262 106.348 104.262 109.662V159C104.262 162.314 106.948 165 110.262 165H159.6C162.914 165 165.6 162.314 165.6 159V109.662C165.6 106.348 162.914 103.662 159.6 103.662Z",
    fill: "url(#paint4_linear_26801_1307)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_26801_1307",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 104,
    y: 103,
    width: 62,
    height: 62
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M159.6 103.662H110.262C106.948 103.662 104.262 106.348 104.262 109.662V159C104.262 162.314 106.948 165 110.262 165H159.6C162.914 165 165.6 162.314 165.6 159V109.662C165.6 106.348 162.914 103.662 159.6 103.662Z",
    fill: "url(#paint5_linear_26801_1307)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_26801_1307)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_26801_1307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.6 141.751L151.097 126.549L139.459 140.405L131.456 132.511L104.262 165H165.6V141.751Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_26801_1307",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 104,
    y: 35,
    width: 62,
    height: 62
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M159.6 35H110.262C106.948 35 104.262 37.6863 104.262 41V90.338C104.262 93.6517 106.948 96.338 110.262 96.338H159.6C162.914 96.338 165.6 93.6517 165.6 90.338V41C165.6 37.6863 162.914 35 159.6 35Z",
    fill: "url(#paint6_linear_26801_1307)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_26801_1307)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_26801_1307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.6 72.5352L151.097 56.9718L139.459 71.1574L131.456 63.0751L104.262 96.338H165.6V72.5352Z",
    fill: "white"
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.21 73.0464C64.076 73.0464 67.21 69.9124 67.21 66.0464C67.21 62.1805 64.076 59.0464 60.21 59.0464C56.344 59.0464 53.21 62.1805 53.21 66.0464C53.21 69.9124 56.344 73.0464 60.21 73.0464Z",
    fill: "url(#paint7_linear_26801_1307)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M119.417 56.1549C122.731 56.1549 125.417 53.4686 125.417 50.1549C125.417 46.8412 122.731 44.1549 119.417 44.1549C116.103 44.1549 113.417 46.8412 113.417 50.1549C113.417 53.4686 116.103 56.1549 119.417 56.1549Z",
    fill: "url(#paint8_linear_26801_1307)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M119.417 125.732C122.731 125.732 125.417 123.046 125.417 119.732C125.417 116.419 122.731 113.732 119.417 113.732C116.103 113.732 113.417 116.419 113.417 119.732C113.417 123.046 116.103 125.732 119.417 125.732Z",
    fill: "url(#paint9_linear_26801_1307)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_26801_1307",
    x: 35.6001,
    y: 111.817,
    width: 61.3381,
    height: 53.1831,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 18,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_26801_1307"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6125 0 0 0 0 0.907 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26801_1307"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.891667 0 0 0 0 0.93753 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_26801_1307",
    result: "effect2_innerShadow_26801_1307"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_26801_1307",
    x: 104.262,
    y: 125.549,
    width: 61.3381,
    height: 39.4507,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 18,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_26801_1307"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6125 0 0 0 0 0.907 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26801_1307"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.891667 0 0 0 0 0.93753 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_26801_1307",
    result: "effect2_innerShadow_26801_1307"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_26801_1307",
    x: 104.262,
    y: 55.9718,
    width: 61.3381,
    height: 40.3662,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 18,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_26801_1307"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6125 0 0 0 0 0.907 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26801_1307"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.891667 0 0 0 0 0.93753 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_26801_1307",
    result: "effect2_innerShadow_26801_1307"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26801_1307",
    x1: 25.6001,
    y1: 36.7188,
    x2: 168.569,
    y2: 166.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26801_1307",
    x1: 66.2691,
    y1: 35,
    x2: 66.2691,
    y2: 165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26801_1307",
    x1: 66.2691,
    y1: 35,
    x2: 66.2691,
    y2: 165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26801_1307",
    x1: 134.931,
    y1: 35,
    x2: 134.931,
    y2: 96.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_26801_1307",
    x1: 134.931,
    y1: 103.662,
    x2: 134.931,
    y2: 165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_26801_1307",
    x1: 134.931,
    y1: 103.662,
    x2: 134.931,
    y2: 165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_26801_1307",
    x1: 134.931,
    y1: 35,
    x2: 134.931,
    y2: 96.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_26801_1307",
    x1: 54.7412,
    y1: 59.0464,
    x2: 70.9308,
    y2: 69.1384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_26801_1307",
    x1: 114.729,
    y1: 44.1549,
    x2: 128.606,
    y2: 52.8051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_26801_1307",
    x1: 114.729,
    y1: 113.732,
    x2: 128.606,
    y2: 122.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollage);
export default __webpack_public_path__ + "static/media/Collage.4d2fff2991e9ea66d7372567385c3302.svg";
export { ForwardRef as ReactComponent };